import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/block')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div>
      <div className='h-16 sticky top-0 flex justify-between items-center bg-background/50 px-4 text-sm'>
        <p>BLOCK</p>
        <nav></nav>
      </div>
      <main className='relative'>
        <Outlet />
      </main>
    </div>
  )
}
